/**
 * Given a data array that has already been filtered to only include one value
 * per year, returns the value for the given year, or N/A if none exists.
 * @param {Array} data - An array of data points to examine.
 * @param {number} year - The year to match when extracting the value.
 * @returns {number|undefined} A number on success, or undefined if the value couldn't be found.
 */
const getValueForYear = (data, year) => (data
  .find(({ year: compare }) => compare === year) || {}).value || undefined;

export default getValueForYear;
